/**
 * Shared vocabulary for the Lexi Performance pages.
 * See docs/LEXI-PERFORMANCE-REPORTS-SPEC.md.
 */

// Tip editions. The underlying tier model is early=T1–T4 / raceTime=T5–T8;
// here we surface the three punter-facing editions with their detail-table badges.
export const EDITIONS = [
  { key: "early", label: "Early", badge: "E" },
  { key: "raceDay", label: "Race-day", badge: "RD" },
  { key: "late", label: "Late", badge: "LT" },
];

export const EDITION_BY_KEY = Object.fromEntries(
  EDITIONS.map((e) => [e.key, e]),
);

// Which edition's #1 tip is the "leg" when no single edition is selected.
export const DEFAULT_LEG_EDITION = "raceDay";

export const FIELD_BUCKETS = [
  { key: "5-7", label: "5–7", places: "top 2", test: (f) => f >= 5 && f <= 7 },
  {
    key: "8-15",
    label: "8–15",
    places: "top 3",
    test: (f) => f >= 8 && f <= 15,
  },
  { key: "16+", label: "16+", places: "top 4", test: (f) => f >= 16 },
];

export const REPORT_TYPES = [
  { key: "multi", label: "Multi", enabled: true },
  { key: "win", label: "Win", enabled: true },
  { key: "place", label: "Place", enabled: true },
  { key: "eachway", label: "Each-Way", enabled: true },
];

export const PERIODS = ["daily", "weekly", "monthly", "custom"];

export const LENSES = [
  { key: "auto", label: "Auto (by field size)" },
  { key: "top2", label: "Top 2" },
  { key: "top3", label: "Top 3" },
  { key: "top4", label: "Top 4" },
];

// Price source for ROI. "sp" = official starting price; "betfair" = the Betfair
// price we published at tip time (results-archive effectivePrice).
export const PRICE_SOURCES = [
  { key: "sp", label: "SP" },
  { key: "betfair", label: "Betfair" },
];

// Whether to include races Lexi didn't tip. "tipped" hides them (the meaningful
// view for tip performance); "all" shows every resulted race.
export const RACE_SCOPES = [
  { key: "tipped", label: "Tipped only" },
  { key: "all", label: "All races" },
];

// A track with fewer than this many legs is flagged "low n" and muted.
export const LOW_N_THRESHOLD = 5;

/** The short detail-table badge for a tip, e.g. "RD1", "E2", "LT1". */
export function tipBadge(tip) {
  const ed = EDITION_BY_KEY[tip?.edition];
  return ed ? `${ed.badge}${tip.rank ?? ""}` : "";
}
